/**
 * Reads a cookie value by name
 * @param name - Cookie name to read
 * @param _document Internal parameter for Dependency Injection [DO NOT USE] - document object
 * @returns Cookie value if found, undefined otherwise
 */
export const getCookie = (
  name: string,
  /* istanbul ignore next */
  _document = document,
): string | undefined => {
  if (typeof window === 'undefined' || !_document?.cookie) {
    return undefined;
  }

  const allCookies = _document.cookie.split(';');

  for (const cookie of allCookies) {
    const [cookieName, cookieValue] = cookie.trim().split('=');
    if (cookieName === name && cookieValue) {
      return decodeURIComponent(cookieValue);
    }
  }

  return undefined;
};

/**
 * Gets the Segment anonymousId from the root domain cookie if it exists
 * Segment stores anonymousId in a cookie named 'ajs_anonymous_id'
 * @param _getCookie Internal parameter for Dependency Injection [DO NOT USE] - function to get cookie
 * @returns anonymousId from root domain cookie, or undefined if not found
 */
export const getSegmentAnonymousIdFromCookie = (
  /* istanbul ignore next */
  _getCookie = getCookie,
): string | undefined => {
  // Segment Analytics.js stores anonymousId in this cookie name
  const SEGMENT_ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
  return _getCookie(SEGMENT_ANONYMOUS_ID_COOKIE);
};
